import type { FacebookShareFormValues } from './types';

import { createShareFormContext } from '~features/integrations/lib/createShareFormContext';

export const {
  ShareFormProvider: FacebookShareFormProvider,
  useShareForm: useFacebookShareForm,
} = createShareFormContext<FacebookShareFormValues>();
